import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { Tagline } from "@/ui/Tagline";
import { getYoutubeVideoEmbedUrl } from "@sourceflow-uk/functions/getYoutubeVideoEmbedUrl";
import cn from "classnames";
import { Col, Container, Ratio, Row } from "react-bootstrap";
import { Buttons } from "src/ui/Buttons";

import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "",
  containerClassName = "",
  tagline,
  prefix,
  global,
  title,
  description,
  buttons = [],
  theme = "light",
  reverse = false,
  video,
  EditableHtml,
  EditableText,
}) {
  const video_embed_url = getYoutubeVideoEmbedUrl(global[`${prefix}.video`] ?? video);

  return (
    <div className={cn(className, classes.ContentSideVideo, { reverse })} data-bs-theme={theme}>
      <ParallaxBackground anim="y2n:x0:z0" image={bg_1} floating={false} className={classes.bg_1} />
      {/* START: CMS Tools editable fix */}
      <EditableText path="video" type="text" className="visually-hidden" />
      {/* END: CMS Tools editable fix */}
      <Container className={containerClassName} fluid>
        <Row className={cn({ "flex-row-reverse": reverse })}>
          <Col xs={12} md={6} className="col">
            <div className="p-5 py-md-0 px-md-6">
              {tagline && <Tagline>{tagline}</Tagline>}
              {title && (
                <EditableText path="title" tag="h3" className="mb-4">
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </EditableText>
              )}
              <EditableHtml path="description" className="content mb-4">
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </EditableHtml>
              {buttons.length > 0 && (
                <Buttons className="justify-content-md-start mb-4" buttons={buttons} />
              )}
            </div>
          </Col>
          <Col xs={12} md={6} className="col">
            <Ratio aspectRatio="16x9">
              <iframe
                width="1920"
                height="1080"
                src={video_embed_url}
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </Ratio>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
